import moment from "moment-timezone";

export const MOMENT_CONSTANTS = {
  time: {
    "12Hours": "h A",
    "24Hours": "HH:00",
  },
  date: {
    shortMonthDay: "MMM Do",
    fullMonthDay: "MMMM Do",
    monthDayYear: "MM/DD/YYYY",
  },
  dateWithTime: {
    monthDay12Hours: "MMM Do, hh:00 A",
    dayMonth12Hours: "Do MMM hh:00 A",
    monthDayYear12Hours: "MMM Do YYYY hh:00 A",
    yearMonthDay24Hours: "YYYY-MM-DDTHH:mm:ss",
  },
};

export const getLocalTimeZone = () => moment.tz(moment.tz.guess())?.format("z");

export const getTimeZone = (timeZone = moment.tz.guess(), isNumber = false) =>
  moment.tz(timeZone || moment.tz.guess())?.format(isNumber ? "Z" : "z");

export const convertYardToUtc = ({
  date,
  timeZone,
  enableFormat = true,
  dateFormat = MOMENT_CONSTANTS.dateWithTime.yearMonthDay24Hours,
}) => {
  const dateWithTimeZone = new Date(
    `${moment(date)?.format(
      MOMENT_CONSTANTS.dateWithTime.yearMonthDay24Hours,
    )}${getTimeZone(timeZone, true)}`,
  );

  return enableFormat
    ? moment(dateWithTimeZone).utc()?.format(dateFormat)
    : moment(dateWithTimeZone).utc();
};

export const convertUtcToYard = ({
  date,
  timeZone = moment.tz.guess(),
  enableFormat = false,
  dateFormat = MOMENT_CONSTANTS.dateWithTime.monthDay12Hours,
}) =>
  enableFormat
    ? moment.utc(date).tz(timeZone)?.format(dateFormat)
    : moment.utc(date).tz(timeZone);

export const getMonthlyToDate = ({
  date,
  enableFormat = true,
  dateFormat = MOMENT_CONSTANTS.date.fullMonthDay,
}) =>
  enableFormat
    ? moment(date).endOf("month")?.format(dateFormat)
    : moment(date).endOf("month");
